import React from "react";
import Header from "../../Components/Header";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import OMSHome from "../../Components/OMS/OMSHome";
import { OMSHNI } from "../../Configuration/Telecaller_URl";

function OmsHni() {
  const storeToken = localStorage.getItem("ssoToken");
  if (storeToken == null) {
    window.location.replace("/");
  }

  return (
    <>
      <Header portal={"TELECALLER"} />
      <SingleSignOnSideBar />
      <main id="main-content">
        <div className="omspage">
          <div className="card-box">
            <OMSHome URL={OMSHNI.PENDIG_DATA_HNI_URL} mainType={"HNI"} />
          </div>
        </div>
      </main>
    </>
  );
}

export default OmsHni;
